import { TextField, Typography, InputAdornment, Box } from '@mui/material'
import React, { ChangeEvent, useEffect, useState } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'
import { InputLabelProps } from '@mui/material/InputLabel'
import { StarLoader, StarLoaderIcon } from '@/src/assets/icons'

interface FieldProps {
  variant?: 'filled' | 'outlined' | 'standard'
  label?: string
  fieldClass?: string
  divClass?: string
  defaultValue?: any
  placeholder?: string
  id?: string
  error?: boolean
  helperText?: string | React.ReactNode | any
  inputLabel?: string
  props?: object
  validation?: UseFormRegisterReturn<string>
  fullWidth?: boolean
  disabled?: boolean
  multiline?: boolean
  maxRows?: number
  minRows?: number
  rows?: number
  suffixIcon?: React.ReactNode
  prefixIcon?: React.ReactNode
  getvalue?: (data: any) => void
  value?: any
  InputLabelProps?: InputLabelProps
  RenderCustomLabel?: React.ElementType
  maxLength?: number
  loading?: boolean | any
  loadingText?: string
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
  onInput?: React.FormEventHandler<HTMLInputElement>
}

const FormTextField = ({
  label = '',
  defaultValue,
  placeholder,
  helperText,
  error,
  validation,
  getvalue,
  disabled,
  value,
  variant = 'outlined',
  fieldClass = '',
  divClass = '',
  maxRows = 5,
  minRows = 5,
  rows,
  suffixIcon,
  prefixIcon,
  multiline = false,
  fullWidth = true,
  inputLabel = '',
  RenderCustomLabel,
  maxLength,
  id = '',
  loading,
  loadingText = 'Generating...',
  inputProps,
  onInput,
  ...props
}: FieldProps) => {
  return (
    <div className={divClass}>
      {RenderCustomLabel && <RenderCustomLabel />}
      {inputLabel && (
        <Typography variant="subtitle2" component="span" color="text.secondary">
          {inputLabel}
        </Typography>
      )}
      {loading ? (
        <>
          <Box
            padding={'1.031rem 0.875rem'}
            borderRadius={'0.625rem'}
            className="cursor-text border border-[#0000003B] hover:border-[#000000]"
          >
            <Box display={'flex'} alignItems={'center'} columnGap={'16px'}>
              <StarLoaderIcon />
              <Typography
                className="flex gap-2 items-center cursor-pointer py-2"
                color="primary.main"
              >
                {loadingText}
              </Typography>
            </Box>
          </Box>
        </>
      ) : (
        <TextField
          id={id}
          label={label}
          defaultValue={defaultValue}
          variant={variant}
          {...validation}
          multiline={multiline}
          autoComplete="off"
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          // rows={rows ?? 0}
          disabled={disabled}
          maxRows={maxRows}
          minRows={minRows}
          value={getvalue ? value : undefined}
          InputProps={{
            startAdornment: prefixIcon && (
              <InputAdornment position="start" className="border-none">
                {prefixIcon}
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end" className="border-none">
                {suffixIcon}
              </InputAdornment>
            ),
            className: `rounded-[0.625rem] border-icon-darkgray ${fieldClass}`
          }}
          fullWidth={fullWidth}
          onChange={e => {
            validation?.onChange?.(e) // ✅ Tell react-hook-form
            getvalue?.(e) // ✅ Also call your own
          }}
          inputProps={{
            maxLength: maxLength,
            ...(inputProps || {})
          }}
          onInput={onInput}
          {...props}
        />
      )}
    </div>
  )
}

export default FormTextField
